<template>
  <div>
    <ais-instant-search :search-client="clientToUse" :index-name="`${$env.getOrigin()}_${index}`">
      <ais-search-box>
        <!-- eslint-disable-next-line vue/no-unused-vars -->
        <div slot-scope="{ currentRefinement, isSearchStalled, refine }">
          <input
            ref="insertCollectionInput"
            v-model="currentRefinement"
            :placeholder="placeholder"
            type="search"
            class="input-main input-font-regular"
            @input="refine($event.currentTarget.value)"
          />
          <ais-state-results>
            <template slot-scope="{ searchResults }">
              <ais-hits v-if="searchResults && searchResults.query.length > 0" class="collections-dropdown--items">
                <!-- 
                    https://codetribellc.atlassian.net/browse/BUL-3413 
                    in this ticket dynamic faceting will be supported (item.status === 'REGISTERED')
                -->
                <div v-if="item.status === 'ACTIVE'" slot="item" slot-scope="{ item }" @click="pick(item, refine)">
                  {{ item[field] }}
                </div>
              </ais-hits>
            </template>
          </ais-state-results>
        </div>
      </ais-search-box>
    </ais-instant-search>
  </div>
</template>

<script>
import globalAlgoliaClient from '../../../services/algoliaClient'

export default {
  name: 'AlgoliaAutocomplete',
  props: {
    algoliaClient: Object,
    index: String,
    placeholder: {
      type: String,
      default: 'Search...'
    },
    selectItem: Function
  },
  data() {
    return {
      query: ''
    }
  },
  computed: {
    clientToUse() {
      // Use the provided client or fall back to the global one
      return this.algoliaClient || globalAlgoliaClient
    }
  }
}
</script>